import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  NgbDateAdapter,
  NgbDateNativeAdapter,
  NgbDateParserFormatter,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';
import { createMask } from '@ngneat/input-mask';
import { OwnerForm } from 'src/app/classes/form-groups/owner-form';
import { SubNationalDivision } from 'src/app/classes/models';
import { CustomNgbDateFormatter } from 'src/app/dependencies/custom-ngb-date-formatter';
import { SubNationalDivisionService } from 'src/app/services/sub-national-division.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-owner-edit',
  templateUrl: './owner-edit.component.html',
  styleUrls: ['./owner-edit.component.less'],
  providers: [
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomNgbDateFormatter }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OwnerEditComponent implements OnInit, OnChanges {
  constructor(
    private SubNationalDivisionService: SubNationalDivisionService,
    private ToastService: ToastService
  ) {}

  @Input() OwnerFormGroup!: OwnerForm;
  @Input() country!: 'US' | 'CA';
  @Input() showSaveButton: boolean = false;
  @Input() showLexisNexisId: boolean = false;
  @Input() hasOwnerSSNAccess: boolean = true;
  @Input() ownerHasSSN: boolean = false;
  @Input() revealedOwnerSSN?: string;
  @Input() isEditMode: boolean = false;
  @Output() saveOwnerEvent = new EventEmitter<boolean>();
  @Output() viewOwnerSSNEvent = new EventEmitter<void>();

  SubNationalDivisions: SubNationalDivision[] = [];
  minDatePickerDate: NgbDateStruct = {
    day: 1,
    month: 1,
    year: 1900
  } as NgbDateStruct;
  maxDatePickerDate: NgbDateStruct = {
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear() - 18
  } as NgbDateStruct;

  phoneMask = createMask('(999) 999-9999');
  ssnFirst5DigitMask = createMask('999-99');
  ownerPercentMask = createMask({
    regex: '^(\\d{1,3}(\\.\\d{1,2})?)$',
    placeholder: ''
  });

  save() {
    this.saveOwnerEvent.emit(true);
  }

  viewOwnerSSN(): void {
    this.viewOwnerSSNEvent.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['revealedOwnerSSN'] &&
      this.revealedOwnerSSN &&
      this.OwnerFormGroup
    ) {
      this.OwnerFormGroup.controls['ssn'].setValue(this.revealedOwnerSSN);
    }
  }

  ngOnInit(): void {
    if (!this.OwnerFormGroup) {
      throw this.ToastService.addErrorToast('Error', 'Missing Owner Form.', {
        returnError: true
      });
    }

    if (!this.country) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing country information.',
        { returnError: true }
      );
    }

    if (this.isEditMode && !this.hasOwnerSSNAccess) {
      this.OwnerFormGroup.controls['ssn'].setValue('');
    }

    this.SubNationalDivisionService.getSubNationalDivisions({
      country: this.country
    }).subscribe({
      next: (SubNationalDivisions) => {
        this.SubNationalDivisions.push(...SubNationalDivisions);
      }
    });
  }
}
